<template>
  <div class="fit">
    <q-card class="fit">
      <q-card-section class="bg-primary text-white">
        <div v-if="survey || !$route.params.report_id" class="row items-center">
          <q-btn
            v-if="$route.params.report_id && collapseOnSelect"
            icon="mdi-arrow-left"
            flat
            @click="$emit('closeReport')"
          ></q-btn>
          <div
            style="display: inline-block; font-family: 'Outfit', cursive"
            class="text-h6"
          >
            {{
              $route.params.report_id && collapseOnSelect
                ? survey.name
                : "Past Surveys"
            }}
          </div>
          <q-btn
            v-if="
              collapseOnSelect &&
              $route.params.report_id &&
              surveyReports.length < 3 &&
              currentUserData.role == 'Admin'
            "
            @click="viewDetailsDialog = true"
            size="md"
            outline
            color="white"
            label="Edit Survey"
            class="q-ml-sm"
          ></q-btn>
          <q-space />

          <q-input
            v-if="!collapseOnSelect || !$route.params.report_id"
            style="max-width: 70%"
            dark
            standout
            v-model="filter.search"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
          <q-btn
            v-if="
              collapseOnSelect &&
              $route.params.report_id &&
              currentUserData.role == 'Admin'
            "
            size="md"
            color="white"
            outline
            label="Organisations"
            :disable="!survey.phpID"
            class="q-mr-sm"
          >
            <q-menu>
              <q-card class="q-pa-sm">
                <div class="row">
                  <div class="col-12">Please Select the Organisations</div>
                  <div class="col-12">
                    <assign-organization
                      dense
                      :id="survey.organizations"
                      label="Organisation"
                      clearable
                      @changed="updateOrganizationsList"
                      multiple
                    />
                  </div>
                </div>
              </q-card>
            </q-menu>
          </q-btn>
          <q-btn
            v-if="
              collapseOnSelect &&
              $route.params.report_id &&
              surveyReports.length < 2
            "
            @click="reattributeScan"
            size="md"
            color="white"
            outline
            label="Re-attribute Scan"
            class="q-mr-sm"
          ></q-btn>
          <q-btn
            v-if="
              collapseOnSelect &&
              $route.params.report_id &&
              surveyReports.length < 2
            "
            @click="exportToCSV"
            size="md"
            color="white"
            outline
            label="Export to CSV"
            class="q-mr-sm"
          ></q-btn>
          <q-btn
            v-if="
              collapseOnSelect &&
              $route.params.report_id &&
              surveyReports.length < 3
            "
            @click="$emit('selectAnotherScan')"
            size="md"
            color="white"
            outline
            label="Stack another survey"
          ></q-btn>
        </div>
        <div
          class="row items-center"
          v-if="!collapseOnSelect || !$route.params.report_id"
        >
          <div
            class="col q-pr-sm col-sm-6"
            v-if="currentUserData.role == 'Admin'"
          >
            <assign-organization
              dense
              :id="filter.organization_id"
              label="Organisation"
              clearable
              dark
              @changed="organizationFilterChanged"
            />
          </div>
          <div class="col">
            <q-btn
              @click="loadAllPastSurveys"
              :loading="pastSurveysLoading"
              size="md"
              color="white"
              outline
              label="Load All"
              class="float-right q-mt-sm"
            ></q-btn>
          </div>
        </div>
      </q-card-section>

      <q-separator />
      <q-card-section
        v-if="!collapseOnSelect || !$route.params.report_id"
        class="q-pa-none"
        :style="`height: calc(100% - ${
          currentUserData.role == 'Admin' ? '127px' : '73px'
        })`"
      >
        <div class="row fit" v-if="pastSurveys">
          <div class="col-12 mt-0 pt-0 fit">
            <datatable
              :filter="filter"
              :flat="true"
              :data="pastSurveys"
              :columns="columns"
              :selection="'single'"
              :externalFilter="externalFilter"
              @rowSelected="handleSingleClick"
              @rowDoubleClick="handleDoubleClick"
              @selectionChanged="handleNewSelection"
            >
              <template slot="body-cell-name" slot-scope="data">
                <q-td :props="data.props">
                  {{ data.props.row.name }}
                  <q-tooltip>{{ data.props.row.name }}</q-tooltip>
                </q-td>
              </template>
              <template slot="body-cell-location" slot-scope="data">
                <q-td :props="data.props">
                  {{ data.props.row.location }}
                  <q-tooltip>{{ data.props.row.location }}</q-tooltip>
                </q-td>
              </template>
              <template slot="body-cell-openInNewTab" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    @click.stop="openInNewTab(data.props.row.id)"
                    round
                    flat
                    size="sm"
                    icon="mdi-open-in-new"
                    color="secondary"
                  >
                  </q-btn>
                </q-td>
              </template>
              <template slot="body-cell-date" slot-scope="data">
                <q-td :props="data.props">
                  {{
                    data.props.row.date != null
                      ? $moment(data.props.row.date).format("DD/MMM/YYYY")
                      : ""
                  }}
                  <q-btn
                    v-if="currentUserData.role == 'Admin'"
                    @click.stop="archiveSurvey(data.props.row.id)"
                    color="secondary"
                    flat
                    icon="mdi-delete"
                    round
                    class="q-ml-sm"
                    :loading="deletingSurveyID == data.props.row.id"
                  >
                    <q-tooltip>Archive Survey</q-tooltip>
                  </q-btn>
                </q-td>
              </template>

              <template slot="body-cell-addSurvey" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    @click="$emit('addSurvey', data.props.row)"
                    round
                    flat
                    size="sm"
                    icon="mdi-plus"
                    color="secondary"
                  >
                  </q-btn>
                </q-td>
              </template>
            </datatable>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              Survey
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <scheduledSurveyForm
            ref="editForm"
            :surveyData="survey"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
            @uploadDataLoading="(state) => (dataUploadLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.uploadData()"
                :loading="dataUploadLoading"
                text
                color="primary"
                class="float-left"
                icon="upload"
                label="Upload Data"
              >
              </q-btn>
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-content-save-all"
                label="Save"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import agGrid from "@/components/agGrid";
import expandedToolbar from "@/components/expandedToolbar";
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import placesAutocomplete from "@/components/googleMaps/placesAutocomplete.vue";
import datepicker from "@/components/wrappers/datepicker.vue";
import scheduledSurveyForm from "@/components/scheduledSurveys/scheduledSurveyForm.vue";
import moment from "moment";
import assignOrganization from "@/components/organizations/assignOrganization.vue";

// import { Notify } from "quasar";

export default {
  props: {
    actionOpensReport: {
      type: Boolean,
      default: true,
    },
    collapseOnSelect: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    filterOutCurrentScanSelection: {
      default: null,
    },
  },
  components: {
    agGrid,
    expandedToolbar,
    datatable,
    placesAutocomplete,
    datepicker,
    scheduledSurveyForm,
    assignOrganization,
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentUserData",
      "selectedRowData",
      "aGGridActionMenu",
      "pastSurveys",
      "pastSurveysLoading",
      "surveyReports",
      "organizationSurveyLinks",
      "survey",
    ]),
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
        style:
          "min-width: 350px;max-width: 350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "date",
        label: "Date",
        align: "left",
        field: "date",
        format: (val) => (val != null ? moment(val).format("DD/MMM/YYYY") : ""),
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "location",
        label: "Starting Location",
        align: "left",
        field: "location",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "assignedUser",
        label: "Assigned User",
        align: "left",
        field: "usersName",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "type",
        label: "Type",
        align: "left",
        field: "type",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "upperLimit",
        label: "Upper Limit",
        align: "left",
        field: "upperLimit",
        sortable: true,
        style:
          "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "lowerLimit",
        label: "Lower Limit",
        align: "left",
        field: "lowerLimit",
        sortable: true,
        style:
          "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
      {
        name: "status",
        label: "Status",
        align: "left",
        field: "status",
        sortable: true,
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
      },
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    dataUploadLoading: false,

    // Filter
    filter: {
      search: "",
      organization_id: null,
      idList: [],
      filterOutList: [],
    },
  }),
  beforeCreate() {
    this.$store.dispatch("loadPastSurveys");
    this.$store.dispatch("loadOrganizationSurveyLinks");
  },
  mounted() {
    if (this.multiSelect) {
      this.columns.unshift({
        name: "addSurvey",
        label: "",
        align: "left",
        field: "",
        sortable: true,
      });
    } else if (
      !this.$route.params.report_id ||
      !this.collapseOnSelect ||
      this.$route.path.includes("reporting")
    ) {
      this.columns.unshift({
        name: "openInNewTab",
        label: "",
        align: "left",
        field: "",
        sortable: true,
      });
    }
  },
  watch: {
    filterOutCurrentScanSelection: function () {
      this.filter.filterOutList = this.filterOutCurrentScanSelection.map(
        (s) => s.id
      );
    },
  },
  methods: {
    handleSingleClick(row) {
      if (this.actionOpensReport) {
        this.$emit("viewReport", row);
        this.viewFormData = row;
      } else {
        this.viewFormData = row;
        this.viewDetailsDialog = true;
      }
    },
    handleDoubleClick(row) {
      this.viewFormData = row;
      this.viewDetailsDialog = true;
    },
    setViewFormData(data) {
      this.viewFormData = data;
    },
    organizationFilterChanged(id) {
      this.filter.organization_id = id;
      this.filter.idList = this.organizationSurveyLinks
        .filter((osl) => osl.organizations_id == id)
        .map((d) => d.surveys_id)
        .flat();
    },
    externalFilter(rows, terms, cols) {
      return rows.filter((row) => {
        let passed = 0;

        // Text Search
        if (this.filter.search != "" && this.filter.search != null) {
          for (let i = 0; i < cols.length; i++) {
            let val = `${row[cols[i].field]}`.toLowerCase();
            passed +=
              val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                ? 1
                : 0;

            if (passed == 1) {
              i = cols.length;
            }
          }
        } else {
          passed += 1;
        }

        // Status Filter
        if (
          this.filter.idList.includes(row.id) ||
          this.filter.organization_id == null
        ) {
          passed += 1;
        }

        // Filter Out Scan List
        if (
          this.filter.filterOutList.length == 0 ||
          !this.filter.filterOutList.includes(row.id)
        ) {
          passed += 1;
        }

        // if (this.multiSelect || !row.mergedScan) {
        //   passed += 1;
        // }

        if (passed == 3) {
          return true;
        } else {
          return false;
        }
      });
    },
    handleNewSelection(selection) {
      this.$emit("selectionChanged", selection);
    },
    async reattributeScan() {
      let result = false;
      try {
        const response = await this.$store.dispatch("createScanReprocessJob", {
          survey_id: this.$route.params.report_id,
        });

        if (response.Result == "Success") result = true;
      } catch (error) {
        result = false;
      }

      if (result) {
        this.$q.notify({
          color: "positive",
          message: "Scan re-processing job created successfully",
          icon: "check",
        });
      } else {
        this.$q.notify({
          color: "negative",
          message: "Scan re-processing job creation failed",
          icon: "warning",
        });
      }
    },
    exportToCSV() {
      window.open(
        "https://huu7hq3m51.execute-api.ap-southeast-2.amazonaws.com/dev/downloadCsv?id=" +
          this.$route.params.report_id
      );
    },
    openInNewTab(id) {
      window.open(
        `https://dev.tdri.simplesoftware.nz/reporting/${id}`,
        "_blank"
      );
    },
    loadAllPastSurveys() {
      this.$store.dispatch("loadPastSurveys", 1);
    },
    archiveSurvey(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this survey, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#3284E3",
      }).then((res) => {
        if (res.value) {
          this.deletingSurveyID = id;
          let payload = {
            id: id,
            status: "deleted",
          };
          this.$store
            .dispatch("saveScheduledSurvey", payload)
            .then((result) => {
              this.deletingSurveyID = null;

              this.$store.dispatch("loadPastSurveys");
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Scheduled Survey has been archived",
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        }
      });
    },
    updateOrganizationsList(val) {
      this.$store
        .dispatch("saveOrganizationSurveysBatch", {
          organizationIds: val,
          surveys_id: this.survey.id,
        })
        .then((result) => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: "Organizations list Updated",
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
